import UserService from "@/services/UserService";

export const namespaced = true;

export const state = {
  users: [],
  usersToday: [],
};

export const mutations = {
  setUsers(state, users) {
    state.users = users;
  },
  setUsersToday(state, usersToday) {
    state.usersToday = usersToday;
  },
};

export const actions = {
  // User Accounts
  list(
    { commit, dispatch },
    { page, page_size, sort, order, section_id, search_term, platoon_id}
  ) {
    return UserService.list({
      page,
      page_size,
      sort,
      order,
      section_id,
      search_term,
      platoon_id,
    })
      .then((res) => {
        commit("setUsers", res.data);
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  add({ dispatch }, user) {
    let obj = { ...user };
    obj.password = obj.password.value;
    obj.platoon_id = obj.platoon_id > 0 ? obj.platoon_id : null;
    obj.section_id = obj.section_id > 0 ? obj.section_id : null;
    obj.height_cm = obj.height_cm ? obj.height_cm : 0;
    obj.weight_kg = obj.weight_kg ? obj.weight_kg : 0;
    obj.devices = obj.devices.filter(
      (d) => d.serial.trim().length > 0 && d.address.trim().length > 0
    );

    return UserService.add(obj)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  edit({ dispatch }, user) {
    let obj = { ...user };
    obj.platoon_id = obj.platoon_id > 0 ? obj.platoon_id : null;
    obj.section_id = obj.section_id > 0 ? obj.section_id : null;
    obj.height_cm = obj.height_cm ? obj.height_cm : 0;
    obj.weight_kg = obj.weight_kg ? obj.weight_kg : 0;
    obj.devices = obj.devices || [];

    obj.devices = obj.devices.filter(
      (d) => d.serial.trim().length > 0 && d.address.trim().length > 0
    );

    return UserService.edit(obj)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  resetPassword({ dispatch }, { udid, new_password }) {
    let obj = { udid, new_password };
    return UserService.resetPassword(obj)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  deactivate({ dispatch }, udid) {
    return UserService.deactivate(udid)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  activate({ dispatch }, udid) {
    return UserService.activate(udid)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  revokeToken({ dispatch }, udid) {
    return UserService.revokeToken(udid)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  topRankingUsers({ dispatch }, { period, label, offset, chunkSize, day, platoon_id, search_term, page_num }) {
    return UserService.topRankingUsers({ period, label, offset, chunkSize, day, platoon_id, search_term, page_num })
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
};
